
<div class="dialog">
    <div *ngIf="data.error; else contentInfo">
      <div class="dialog-icon-container">
        <div class="dialog-icon-error" data-test="icon-error">
          <span></span>
        </div>
      </div>
      <h3 class="dialog-title-error" data-test="title-error">Nosso sistema não funcionou como deveria</h3>
      <div class="dialog-content-error" data-test="content-error">
        <p>Já estamos trabalhando para resolver isso.</p>
        <p>Você pode tentar de novo agora ou voltar mais tarde.</p>
      </div>
    </div>
    <ng-template #contentInfo>
      <div class="dialog-icon-container">
        <div class="dialog-icon" data-test="icon-info">
          <span></span>
        </div>
      </div>
      <h3 class="dialog-title" data-test="dialog-title">Estamos gerando seu relatório</h3>
      <div class="dialog-content" data-test="dialog-content">
        <p>Você receberá um link para fazer o download no e-mail <b>{{ data.email }}</b> assim que ele estiver pronto.</p>
        <p>Esse processo pode levar alguns minutos ou até horas.</p>
      </div>
    </ng-template>
    <div class="dialog-actions-content">
      <button mat-dialog-close (click)="dialogInfoActions.close()" class="button-default button-confirm" cdkFocusInitial>
        Ok
      </button>
    </div>
</div>